import React from 'react'

export default function Contact() {
    return (
        <div className='contact' style={{padding: '2rem', lineHeight: '1.8', maxWidth: '900px', margin: '0 auto', marginTop:'13rem' }}>
            <div className='head'>
                Kidorise Help Center | 24x7 Customer Care Support
            </div>
            <div className='content'>
                <p>
                    The Kidorise Help Centre is designed to make your experience as smooth and delightful as possible. Whether you’re looking for updates on your order, need to modify delivery details, or want help with returns and refunds — our support resources are here to assist you every step of the way.
                </p>
                <br />
                <p>
                    You’ll also find helpful information related to payments, account details, product care, and much more. To make it even easier, the Help Centre features intuitive filters on the left-hand side so you can quickly locate answers to your specific queries — without any hassle.
                </p>
                <br />
                <p>
                    Need personalized assistance? You can reach out to our Kidorise Help Centre support team for direct help. Our support executives are committed to resolving your concerns promptly, ensuring a seamless and joyful shopping experience.
                </p>
                <br />
                <p>
                    Feel free to share this page with friends and family too — we’re here to support all parents and caregivers on their journey. Once your queries are resolved, you can jump back into discovering thoughtfully designed baby products and essentials, crafted with love and care.
                </p>
                <br />
                <p>
                    Be sure to check back during festive sales and special events for exclusive offers and deals — all in one trusted place.
                </p>
                <br />
                <p style={{fontStyle:'italic'}}>Last updated: 21-Aug-2025</p>
            </div>
            
            <div className='contact-details'>
                <p className='contact-details' style={{textTransform:'none'}}>Email : kidorise@gmail.com</p>
                <p className='contact-details'>Phone : +91 9953110193</p>
                <p className='contact-details'>Address : Plot No. 40, Street No. 4, Rajender Nagar Industrial Area, Mohan Nagar, Ghaziabad, Uttar Pradesh – 201006</p>
            </div>
        </div>
    )
}
